
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.6 1.935c-1.766 0-2.867 1.115-3.305 3.345H7.53v1.071H3.18l-.016.473v.531l.016.374h3.843v1.07h-3.71c.205.997.587 1.769 1.146 2.317.564.542 1.317.813 2.257.813.864 0 1.719-.182 2.565-.548v1.245a6.39 6.39 0 01-2.631.54c-1.312 0-2.369-.37-3.171-1.112-.797-.747-1.323-1.832-1.577-3.254H.523V7.729h1.262l-.017-.349v-.365l.017-.664H.523v-1.07h1.361C2.1 3.835 2.612 2.71 3.42 1.9 4.228 1.095 5.288.69 6.6.69c1.111 0 2.124.268 3.037.805l-.59 1.154c-.918-.476-1.734-.714-2.448-.714z"}})])
          )
        }
      }
    